import React from 'react';
import { HStack, Icon, IconButton, Td, Text, Tr } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import Authorizer from '../../../../../../../../../../../../../../components/Authorizer';
import { CodeActions, CodeStatuses } from '../../../../../../../../../../../../../../constants/codes';
import { CREATE_ITEM_CODE_STATUS_APPLIED, CREATE_ITEM_CODE_STATUS_WAIVED } from '../../../../../../../../../../../../../../constants/permissions';
import ButtonStates from '../../style/ButtonStates';
import {
  getAuditApprovalAnalyticsId, getAuditRejectionAnalyticsId,
  getCheckboxAnalyticsId, getInquireAnalyticsId, getWaiveAnalyticsId, handleAuditApproval, handleAuditRejection,
  handleCheckboxChange, handleInquireClick, handleWaveClick
} from '../../util';

const iconWidth = '24px';

const Row = ({ code, itemCode, onChange }) => {
  const { status } = itemCode || {};
  const { id: codeId, letter: codeLetter } = code;

  const getColor = type => ButtonStates[status || CodeStatuses.Default][type].color;
  const getIcon = type => (
    <Icon
      as={ButtonStates[status || CodeStatuses.Default][type].icon}
      h={iconWidth}
      w={iconWidth}
    />
  );

  return (
    <Tr justifyContent="space-between" key={code} px={2} width="236px">
      <Td padding={2} textAlign="center">
        <HStack alignItems="center">
          <IconButton
            color={getColor(CodeActions.Suggest)}
            data-analytics-id={getCheckboxAnalyticsId(status)}
            icon={getIcon(CodeActions.Suggest)}
            variant="unstyled"
            onClick={handleCheckboxChange(onChange, status, codeId, codeLetter)}
          />
          <Text>{codeLetter}</Text>
        </HStack>
      </Td>
      <Authorizer permission={CREATE_ITEM_CODE_STATUS_APPLIED}>
        <Td bgColor="greyScale.100" p={2} textAlign="center">
          <IconButton
            color={getColor(CodeActions.Apply)}
            data-analytics-id={getAuditApprovalAnalyticsId(status)}
            icon={getIcon(CodeActions.Apply)}
            variant="unstyled"
            onClick={handleAuditApproval(onChange, status, codeId, codeLetter)}
          />
          <IconButton
            color={getColor(CodeActions.Reject)}
            data-analytics-id={getAuditRejectionAnalyticsId(status)}
            icon={getIcon(CodeActions.Reject)}
            variant="unstyled"
            onClick={handleAuditRejection(onChange, status, codeId, codeLetter)}
          />
        </Td>
      </Authorizer>
      <Authorizer permission={CREATE_ITEM_CODE_STATUS_WAIVED}>
        <Td padding={2} textAlign="center">
          <IconButton
            color={getColor(CodeActions.Waive)}
            data-analytics-id={getWaiveAnalyticsId(status)}
            icon={getIcon(CodeActions.Waive)}
            variant="unstyled"
            onClick={handleWaveClick(onChange, status, codeId, codeLetter)}
          />
          <IconButton
            color={getColor(CodeActions.Inquire)}
            data-analytics-id={getInquireAnalyticsId(status)}
            icon={getIcon(CodeActions.Inquire)}
            variant="unstyled"
            onClick={handleInquireClick(onChange, status, codeId, codeLetter)}
          />
        </Td>
      </Authorizer>
    </Tr>
  );
};

Row.propTypes = {};

export default Row;
